import { Component } from '@angular/core';

@Component({
  selector: 'tabs-placeholder',
  templateUrl: './tabs-placeholder.component.html'
})
export class TabsPlaceholderComponent {
  constructor() {}
}
